<template>
  <div class="flex flex-col gap-4">
    <div class="overflow-x-auto rounded-lg border">
      <UmisisDataTable
        :loading="isLoading"
        :order-by="orderBy"
        :order-direction="orderDirection"
        :fields="fields"
        :rows="getItems"
        @sort-changed="handleSort"
      >
        <template #[titleCellSlotName]="{ row, value }">
          <div class="w-96 max-w-[24rem] min-w-0">
            <TaskTitleForList :task="row" :readonly="readonly" :value="value" />
          </div>
        </template>
      </UmisisDataTable>
    </div>

    <Pagination
      v-model:page="tasksStore.page"
      :items-per-page="tasksStore.perPage"
      :total="tasksStore.total ?? 0"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia'
import { computed, onMounted, watch } from 'vue'
import UmisisDataTable from '../../../../../../../resources/js/components/umisis/generic/UmisisDataTable.vue'
import { Pagination } from '../../../../../../../resources/js/components/ui/pagination/index.js'
import { useTaskList } from '../../composables/useTaskList.js'
import { getTaskTableFieldsForContext } from '../../config/taskListConfig.js'
import { useTasksStore } from '../../stores/tasksStore.js'
import TaskTitleForList from './TaskTitleForList.vue'

const props = defineProps({
  context: {
    type: String,
    required: true,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
})

const tasksStore = useTasksStore(props.context)
const { getItems, isLoading, orderBy, orderDirection, page, perPage } = storeToRefs(tasksStore)
const { fetchTaskList } = useTaskList(tasksStore, props.context)
const titleCellSlotName = 'cell(title)'

const fields = computed(() => {
  return getTaskTableFieldsForContext(props.context).map((field) => {
    if (field.name === 'title') {
      return field
    }

    if (!field.component) {
      return field
    }

    return {
      ...field,
      resolveProps: (row, currentField, index) => ({
        task: row,
        context: props.context,
        readonly: props.readonly,
        ...(typeof field.resolveProps === 'function' ? field.resolveProps(row, currentField, index) : {}),
      }),
    }
  })
})

const handleSort = (params) => {
  tasksStore.sortChanged(params)
}

watch([page, perPage, orderBy, orderDirection], async () => {
  await fetchTaskList()
})

onMounted(async () => {
  await fetchTaskList()
})
</script>
